import styled from "styled-components";

import LoadingAnimation from "components/organisms/LoadingAnimation";

export const InfoWrapper = styled.div`
	height: calc(100vh - 100px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export function FullPageLoading() {
	return (
		<InfoWrapper>
			<LoadingAnimation />
		</InfoWrapper>
	);
}
